import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'

export const BatteryQuickChargeTime = withFacetContext(
    FacetName.battery_quick_charge_time_values,
    withFilterContext(FilterName.battery_quick_charge_time_values, SearchFiltersDropdown, {
        title: 'Public charging',
        hideLabel: false,
    })
)
